import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

export const getEmployeeTaxFormsRequirementName = (
  requirement: PayeeRequirement
) => requirement.name || "Tax form requirement";
